import React from "react"

interface MenuItemCustomizationListProps {
  onClose: () => void,
  variantOptions: object[]
}

class MenuItemCustomizationListInner extends React.Component<MenuItemCustomizationListProps> {
  renderVariation(variation, index) {
    return (
      <li className="pb-3" key={index}>
        { variation.name }
      </li>
    )
  }

  render() {
    const { variantOptions, onClose } = this.props

    return (
      <div className="relative p-4 border border-gray-300 rounded-lg flex-grow flex flex-col justify-between">
        <div>
          <div className="text-xl font-600 mb-2">
            Personalize It!
          </div>
          <p className="mb-6 text-lg">
            Personalize your meal with these swaps and upgrade options:
          </p>
          <ul className="list-disc pl-5">
            { variantOptions.map(this.renderVariation) }
          </ul>
        </div>
        <button
          onClick={onClose}
          className="inline-block text-center rounded-full leading-snug
            no-underline transition-all duration-200 ease-in-out
            active:[box-shadow:0px_4px_4px_0px_rgba(0,0,0,0.25)_inset]
            hover:no-underline w-full text-base border border-black px-6 py-3.5
            bg-white text-black focus:bg-gray-neutral hover:bg-gray-neutral"
        >
          Close
        </button>
      </div>
    )
  }
}

export function MenuItemCustomizationList(props: MenuItemCustomizationListProps) {
  return <MenuItemCustomizationListInner {...props} />
}
